import React from "react";
import RichText from "@nvs/gatsby-theme-leap-core/src/components/hoc/components/rich-text";
import InformationPanel from "@nvs/gatsby-theme-leap-core/src/components/hoc/components/information-panel";
import Section from "@nvs/gatsby-theme-leap-core/src/components/hoc/components/section/section";
import useTranslation from "@nvs/gatsby-theme-leap-core/src/hooks/useTranslation";
import { NovartisPatientSupportSVG } from "../../../../../../../assets/images/novartisPatienSupport";
import SocialNetworks from "@nvs/gatsby-theme-leap-core/src/components/hoc/components/social/social-networks";
import { EventPosition } from "@nvs/gatsby-theme-leap-core/src/services/analytics-interfaces";

const ConfirmationFooter = () => {
const socialNetworks =   [
    {
      "name": "facebook",
      "link": "https://www.facebook.com/login/?next=https%3A%2F%2Fwww.facebook.com%2FKISQALI"
    },
    {
      "name": "instagram",
      "link": "https://www.instagram.com/kisqali/"
    }
  ]
	const { t } = useTranslation();

	return (
		<Section>
			<InformationPanel>
				<div className='flex flex-col gap-5'>
					<div className='flex flex-col lg:flex-row items-center justify-center gap-2 text-center text-2xl'>
						<p><RichText html={t("pages.confirmation.footer.title")} /></p>
						<NovartisPatientSupportSVG className='text-font max-w-[275px] lg:max-w-none' />
					</div>
					<p>
						<RichText html={t("pages.confirmation.footer.description")} />
					</p>
                    { socialNetworks.length > 0 && 
						<>
							
							<div className="flex w-full justify-center">
								<SocialNetworks position={EventPosition.Body} />
							</div>
						</>
					}
				</div>
			</InformationPanel>
		</Section>
	);
};

export default ConfirmationFooter;
